export default __webpack_public_path__ + "media/images/favicon-5b9bb17add729a749b3b3cc8bb48fa9d.svg";